import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';
import { getTagList } from '@/lib/queries';

const hotTags = getTagList().slice(0, 6);

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-primary-900/70 bg-primary-950">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-base font-bold text-background-50">
                日
              </span>
              <span className="text-[15px] font-bold text-foreground-50">日韩成人电影</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-500">
              面向成年观众的日韩影视资讯与影片介绍平台。我们只做资料整理与内容推荐，不提供任何影片播放或下载服务。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-md border border-primary-800 px-2.5 py-1.5 text-[11px] text-primary-200">
              <i className="ri-shield-check-line text-sm" />
              仅限 18 岁以上成人访问
            </div>
          </div>

          <div>
            <h3 className="font-label text-xs uppercase tracking-[0.24em] text-accent-500">站内导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-foreground-400 transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-foreground-400 transition-colors hover:text-accent-400">
                  影视资讯
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-foreground-400 transition-colors hover:text-accent-400">
                  全站搜索
                </Link>
              </li>
              <li>
                <Link to="/favorites" className="text-foreground-400 transition-colors hover:text-accent-400">
                  我的收藏
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 transition-colors hover:text-accent-400">
                  关于本站
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-label text-xs uppercase tracking-[0.24em] text-accent-500">影片分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5 text-sm">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="text-foreground-400 transition-colors hover:text-accent-400"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-xs uppercase tracking-[0.24em] text-accent-500">热门标签</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotTags.map((tag) => (
                <Link
                  key={tag.name}
                  to={`/tag/${encodeURIComponent(tag.name)}`}
                  className="rounded-full border border-primary-800 bg-primary-900/40 px-2.5 py-1 text-[11px] text-primary-100 transition-colors hover:border-accent-500 hover:text-accent-300"
                >
                  {tag.name}
                </Link>
              ))}
            </div>
            <p className="mt-5 text-xs leading-relaxed text-foreground-600">
              联系邮箱：
              <span className="text-foreground-400">contact@jkapf-demo.com</span>
            </p>
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-primary-900/80 bg-primary-950/60 px-4 py-3 text-[11px] leading-relaxed text-foreground-600">
          免责声明：本站所有影片名称、封面、演职人员及剧情介绍均为演示用途的虚构内容，与任何真实作品或人物无关。本站不提供、不存储、不传播任何影视文件，内容仅面向成年观众，请遵守所在地法律法规。
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-primary-900/70 pt-6 text-[11px] text-foreground-600 sm:flex-row">
          <p>© 2026 日韩成人电影 · 演示站点，保留所有权利</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/about" className="transition-colors hover:text-accent-400">
              使用说明
            </Link>
            <Link to="/about" className="transition-colors hover:text-accent-400">
              免责声明
            </Link>
            <span className="flex items-center gap-1">
              <i className="ri-time-line text-sm" />
              片单更新于 2026.10.18
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}